import styled from "styled-components/macro";

export const Container = styled.div`
  padding-top: 60px;
  margin-bottom: 50px;
  text-align: center;
  margin: auto;
  max-width: 900px;
  color: var(--grey-0);

  .guide {
    a {
      margin-top: 0 !important;
      border-bottom-width: 0;
    }
    a:first-child {
      margin-right: 24px;
    }
  }

  .admin-warning {
    color: red;
    background: #ff00001a;
    padding: 1em;
    margin-bottom: 1em;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    position: relative;

    h1 {
      margin: 0;
    }
    a {
      font-weight: 500;
      margin-top: 6px;
    }

    .header-left {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }

    .header-center {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .header-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }

    .guide {
      /* background: var(--menu-color-hover); */
    }
  }

  .settings-lockup {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    svg {
      transform: rotate(-90deg);
      transition: transform 200ms ease-in-out;
    }
    .settings-open {
      svg {
        transform: rotate(0deg);
      }
    }
  }

  .section-header {
    margin-bottom: 16px;
  }

  .footer .right-side {
    margin-top: 0 !important;
  }

  .toggle {
    display: flex;
    /* gap: 15px; */
    margin-bottom: -2em;
    justify-content: flex-end;

    span,
    a {
      display: block;
      padding: 10px;
      border-radius: 8px;
      color: var(--grey-0);
    }

    span {
      background: var(--menu-color-hover);
      font-weight: 600;
    }
  }

  .formContainer {
    background-color: var(--menu-color);
    box-shadow: var(--default-drop-shadow);
    padding: 36px;
    border-radius: 24px;
    text-align: left;
    margin: auto auto 50px auto;
    max-width: 900px;
  }

  .step-two-heading {
    margin-bottom: 32px;

    h3 {
      margin: 0 0 6px 0;
      font-size: 20px;
    }

    p {
      margin: 0;
    }
  }

  .step-one-hint {
    margin-bottom: 14px !important;
  }

  .variable {
    color: #17abcc;
    background-color: #fff;
    padding: 2px 4px;
    border-radius: 4px;
  }

  .editPluginTitle {
    font-family: "GT Super Text";
    font-size: 32px;
    font-weight: 400;
  }

  .edit-plugin-form {
    .settings-row {
      display: flex;
      justify-content: space-evenly;
      gap: 20px;
      label {
        width: 100%;
        input {
          width: calc(100% - 24px);
          margin-right: 0px;
        }
      }
    }

    input.read-only {
      background: var(--menu-color-hover);
      border: 1.5px solid var(--menu-color-hover);
      border-radius: 8px;
      padding: 8px 12px;
      color: var(--grey-1);
      cursor: default;
      ::selection {
        background: none;
      }
      ::-moz-selection {
        background: none;
      }
    }

    label#name {
      input {
        width: 300px;
      }
    }

    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      width: 100%;
    }
  }

  .edit-plugin-form .step-one-field {
    display: block;
    margin-bottom: 2em;
    width: 100%;
    font-family: Inter;
    font-weight: 500;
  }

  .edit-plugin-form .step-one-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .edit-plugin-form .step-one-textarea {
    border: 1.5px solid var(--grey-2);
    border-radius: 8px;
    padding: 12px;
    margin-top: 8px;
    font-size: 16px;
    font-family: Inter;
    display: block;
    width: 100%;
    font-weight: 500;
    resize: none;
    background: var(--menu-color);
    color: var(--grey-0);
    box-sizing: border-box;
  }

  .edit-plugin-form .step-one-textarea:focus {
    border: 1.5px solid var(--primary-cta);
  }

  .edit-plugin-form .deletePluginButton {
    margin: 0 !important;
    padding: 8px 16px 8px 12px !important;
    border-radius: 12px !important;
    display: flex;
    align-items: center;
    background-color: #ea47131a !important;
  }

  .edit-plugin-form .deletePluginButton svg {
    padding-right: 6px;
  }

  .edit-plugin-form .deletePluginButton svg path {
    fill: #ea4713;
  }

  .edit-plugin-form .deletePluginButton p {
    color: #ea4713;
  }

  .edit-plugin-form .deletePluginButton:disabled {
    opacity: 0.9;
    background: var(--grey-2) !important;
  }

  .test-section-toggle {
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
    margin-top: 4px;

    svg {
      width: 12px;
      height: 12px;
      transform: rotate(-90deg);
      transition: transform 200ms ease-in-out;
    }

    svg path {
      fill: var(--grey-2);
    }

    &.is-open svg {
      transform: rotate(0deg);
    }
  }

  .test-section-container {
    margin-top: 12px;
    padding: 20px;
    border: 1px solid var(--grey-3);
    border-radius: 14px;
    background: var(--menu-color);
  }

  .test-section-motion {
    overflow: hidden;
  }

  .testing-area {
    .pluginTestingUnavailableMessage {
      margin: 0;
    }

    .testerFieldLabel {
      display: block;
      margin-bottom: 2em;
      width: 100%;
      font-family: Inter;
      font-weight: 500;
    }

    .testerFieldHeading {
      font-weight: 500;
      margin-bottom: 8px;
    }

    .testerFieldHeading--stacked {
      margin-top: 12px;
    }

    .testerFieldHeading--compact {
      margin-top: 8px;
    }

    .testerWordCountHint {
      font-size: 0.9em;
      color: var(--grey-1);
      margin-top: 5px;
    }

    .testerValidationErrors {
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .testerValidationErrorsList {
      margin-left: 20px;
    }

    .testerRunButtonRow {
      display: flex;
      justify-content: flex-start;
      margin: 36px 0 0 0;
    }

    .footer {
      margin-top: 24px;
      margin-bottom: 24px;
    }

    .test-result-container {
      margin-top: 42px;
    }

    .test-response {
      font-weight: 500;
      padding: 10px;
      border-radius: 12px;
      background-color: var(--menu-color-hover);
      margin-top: 10px;
      margin-bottom: 10px;
      h4 {
        font-weight: 500;
        color: var(--grey-1);
        font-family: "Inter", Helvetica, sans-serif;
      }
      p {
        margin-top: 1em;
        line-height: 1.6;
      }
    }
    .test-example-header {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      margin-bottom: 8px;
    }

    .test-example-field {
      display: block;
      margin-bottom: 2em;
      width: 100%;
      font-family: Inter;
      font-weight: 500;
    }

    .test-example-button {
      margin: 0 !important;
      padding: 4px 10px !important;
      min-height: 28px !important;
      height: 28px !important;
      font-size: 0.8rem !important;
      line-height: 1 !important;
    }

    .test-example-button::before {
      border-radius: 8px !important;
    }

    .story-bible-section {
      margin-top: 10px;
    }

    .story-bible-section .story-bible-toggle + * {
      margin-top: 8px;
    }

    .story-bible-toggle {
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      background: transparent !important;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      width: fit-content;
    }

    .story-bible-toggle-label {
      margin: 0;
      color: var(--grey-0);
      font-weight: 500;
      line-height: 1.2;
    }

    .story-bible-toggle-caret {
      display: block;
      width: 12px;
      height: 12px;
      margin-top: 0;
      transform: rotate(0deg);
      transition: transform 160ms ease-in-out;
    }

    .story-bible-toggle-caret path {
      fill: var(--grey-2);
    }

    .story-bible-toggle.is-collapsed .story-bible-toggle-caret {
      transform: rotate(-90deg);
    }

    .credits-display {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      gap: 16px;

      margin-top: 8px;

      .credit-amount {
        display: flex;
        align-items: center;
        // font-size: 12px;
        font-family: "IBM Plex Mono", monospace;
        font-weight: 400;
        line-height: 124.2%;
        color: var(--grey-0);
        letter-spacing: 0.84px;

        svg {
          width: 17px;
          margin-left: 5px;
          path {
            fill: var(--grey-1);
          }
        }
      }
    }
  }

  .edit-plugin-form .step-one-field:has(~ .error),
  .testing-area .testerFieldLabel:has(~ .error) {
    margin-bottom: 0;
  }

  .fieldError {
    border: 1.5px solid red;
  }

  .error {
    display: block;
    padding: 0.5em;
    color: red;
    margin-bottom: 1rem;
  }
`;
